import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import {includes as _includes, without as _without} from 'lodash';

import './style.scss';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';

class TrackControls extends React.PureComponent {
	static propTypes = {
		onOrbitsChange: PropTypes.func,
		onTypeChange: PropTypes.func,
		orbits: PropTypes.object,
		types: PropTypes.object,
	};

	constructor(props) {
		super(props);

		this.onTypeChange = this.onTypeChange.bind(this);
	}

	onTypeChange(key) {
		this.props.onTypeChange(key);
	}

	onOrbitChange(orbit) {
		ReactGA.event({
			category: 'Map content',
			action: 'Switch on/off orbital trajectory',
			label: 'map',
		});

		const currentOrbitKeys = this.props.orbits.activeKeys;
		let updatedOrbitKeys = _includes(currentOrbitKeys, orbit)
			? _without(currentOrbitKeys, orbit)
			: [...currentOrbitKeys, orbit];
		this.props.onOrbitsChange(updatedOrbitKeys);
	}

	render() {
		const types = this.props.types;
		const orbits = this.props.orbits;

		return (
			<div className="eo4sdDrrInsarVietnam20-track-controls">
				{types?.keys?.length > 1 ? (
					<div className="eo4sdDrrInsarVietnam20-track-control">
						<span>Projected direction</span>
						<ButtonSwitch ghost onClick={this.onTypeChange}>
							{types.keys.map(key => {
								return (
									<ButtonSwitchOption
										key={key}
										value={key}
										active={key === types.activeKey}
									>
										{key}
									</ButtonSwitchOption>
								);
							})}
						</ButtonSwitch>
					</div>
				) : null}
				<div className="eo4sdDrrInsarVietnam20-track-control">
					<span>Orbital trajectory</span>
					<div className="eo4sdDrrInsarVietnam20-track-control-checkboxes">
						{orbits.keys.map(key => {
							return (
								<label key={key}>
									<input
										type="checkbox"
										onChange={this.onOrbitChange.bind(this, key)}
										checked={_includes(orbits.activeKeys, key)}
									/>
									<span>{key}</span>
								</label>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}

export default TrackControls;
